export const SECOND = 1000;
export const FIVE_SECONDS = SECOND * 5;
export const TEN_SECONDS = SECOND * 10;
export const MINUTE = SECOND * 60;
export const TWO_MINUTES = MINUTE * 2;
export const FIVE_MINUTES = MINUTE * 5;
